import React, { useState, useEffect, useRef } from 'react';
import { filesService } from '../../services/files';
import { usersService } from '../../services/users';
import { channelsService } from '../../services/channels';
import { favoritesService } from '../../services/favorites';
import './UserSettings.css';

const UserSettings = ({ user, directMessageUnread = {}, onClose, onStartPrivateChat, onNavigate, onLogout }) => {
  const [showPrivateChats, setShowPrivateChats] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [showUserSelect, setShowUserSelect] = useState(false);
  //const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [privateChannels, setPrivateChannels] = useState([]);
  const [existingChatUserIds, setExistingChatUserIds] = useState(new Set());
  const [favoritesChannel, setFavoritesChannel] = useState(null);

  // Фейковые данные для демонстрации
  const privateChats = [
    { id: '1', name: 'Анна', lastMsg: 'Привет! Как дела?', avatar: 'А' },
    { id: '2', name: 'Пётр', lastMsg: 'Встречаемся завтра?', avatar: 'П' },
    { id: '3', name: 'Елена', lastMsg: 'Спасибо за помощь!', avatar: 'Е' },
  ];

  const loadLastActive = () => {
    const siteId = localStorage.getItem('lastSiteId');
    const channelId = localStorage.getItem('lastChannelId');
    return { siteId, channelId };
  };

  const handleLogoutClick = () => {
    if (window.confirm('Вы уверены, что хотите выйти?')) {
      onLogout();
    }
  };

  const loadPrivateChannels = async () => {
    try {
      const data = await channelsService.getPrivateChannels();
      setPrivateChannels(data);
      const { siteId, channelId } = loadLastActive();
      const channelToSelect = data.find(c => c.channelId === channelId) || privateChannels[0];
      if (channelToSelect) {
        onNavigate('channel', { 
          id: channelToSelect.channelId, 
          name: channelToSelect.otherUserName,
          otherUserId: channelToSelect.otherUserId,
          canWrite: true,   // ✅
          canCall: true
        });
      }
      // Обновляем список ID пользователей, с кем есть чат
      const userIds = data
        .filter(chat => chat.channelName)
        .map(chat => {
          const ids = chat.channelName.replace('DM_', '').split('-');
          return ids.find(id => id !== user.id);
        })
        .filter(id => id);
      setExistingChatUserIds(new Set(userIds));
    } catch (error) {
      console.error('Ошибка загрузки личных чатов:', error);
    }
  };
   // ЗАГРУЗКА РЕАЛЬНЫХ ПОЛЬЗОВАТЕЛЕЙ
   useEffect(() => {
    const loadUsers = async () => {
      setIsLoading(true);
      try {
        const data = await usersService.getAllUsers();
        // Фильтруем, чтобы не показывать текущего пользователя
        const filtered = data.filter(u => u.id !== user.id);

        setAllUsers(filtered);
      } catch (error) {
        console.error('Ошибка загрузки пользователей:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadUsers();
  }, [user.id]);

  /*
  const handleStartChat = () => {
    if (selectedUser) {
      onStartPrivateChat(selectedUser);
      setShowUserSelect(false);
   //   setSelectedUser(null);
    }
  };
*/
    // Создание личного чата
    const handleStartPrivateChat = async (selectedUser) => {
        if (!selectedUser) return;
        
        try {
          // Сортируем ID, чтобы канал был уникальным для пары
          const sortedIds = [user.id, selectedUser.id].sort().join('-');
          const channelName = `DM_${sortedIds}`;
          
          // Вызываем создание канала через API
          const newChannel = await channelsService.createPrivateChannel(channelName, user.id, selectedUser.id);
          //console.log('✅ Личный чат создан:', newChannel);
          
          // Закрываем модалку и переключаемся на чат
          setShowUserSelect(false);
         // setSelectedUser(null);
          loadPrivateChannels();
          // Уведомляем родительский компонент, чтобы переключиться на канал
          if (onNavigate) {
            onNavigate('channel', { 
                id: newChannel.id, 
                name: selectedUser.username,
                otherUserId: selectedUser.id,
                canWrite: true,   // ✅
                canCall: true
              });
          }
        } catch (error) {
          console.error('❌ Ошибка создания личного чата:', error);
        }
      };
// Загрузка личных чатов
useEffect(() => {
    loadPrivateChannels();
  }, [user.id]);
  //Избранное
  useEffect(() => {
    const checkFavoritesChannel = async () => {
      try {
        const channel = await favoritesService.getFavoriteChannel();
        if (channel && channel.id) {
          setFavoritesChannel(channel);
          const { siteId, channelId } = loadLastActive();
          if(channel.id === channelId)
          {
            onNavigate('channel', { 
              id: channel.id, 
              name: '⭐ Избранное',
              canWrite: channel.canWrite ?? true,   // ✅
              canCall: channel.canCall ?? true      // ✅
            });
          }
        }
      } catch (error) {
        console.error('Ошибка получения канала:', error);
      }
    };
    checkFavoritesChannel();
  }, []);

  

  // useEffect(() => {
  //   const { siteId, channelId } = loadLastActive();
    
  //     if (privateChannels.length > 0) {
  //       // Ищем канал по ID (включая личные и избранное)
  //       const channelToSelect = privateChannels.find(c => c.id === channelId) || privateChannels[0];
  //       if (channelToSelect) {
  //         onNavigate('channel', { 
  //           id: channelToSelect.id, 
  //           name: channelToSelect.otherUserName 
  //         });
          
  //       }
  //     if(favoritesChannel.id === channelId)
  //     {
  //       onNavigate('channel', { 
  //         id: favoritesChannel.id, 
  //         name: '⭐ Избранное'
  //       });
  //       return;
  //     }
  //   }
  //   // Сначала пытаемся восстановить канал
    
  // }, [favoritesChannel, privateChannels]);

  const formatUnreadCount = (count) => {
    if (count <= 999) return count.toString();
    if (count < 1000000) return (count / 1000).toFixed(1).replace('.0', '') + 'k';
    return (count / 1000000).toFixed(1).replace('.0', '') + 'M';
  };

  return (
    <div className="user-settings-container">
      <div className="user-settings-header">
        <h2>{user?.username || 'Пользователь'}</h2>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>
      
      <div className="user-settings-body">
        {/* Кнопка для открытия личных данных */}
        <button 
          className="nav-btn personal-data-btn" 
          onClick={() => onNavigate('personal')}
        >
          👤 <span className="nav-label">Личные данные</span>
        </button>

        {/*Избранное*/}
        {favoritesChannel && (
          <button 
            className="nav-btn" 
            onClick={() => {
              if (onNavigate) {
                onNavigate('channel', { 
                  id: favoritesChannel.id, // Реальный ID из БД
                  name: '⭐ Избранное',
                  canWrite: true,   // ✅
                  canCall: true
                });
              }
            }}
          >
            ⭐ <span className="nav-label">Избранное</span>
          </button>
        )}
        
        {/* Личная переписка */}
        <div className="private-messages-section">
          <div className="section-header" onClick={() => setShowPrivateChats(!showPrivateChats)}>
            <h3>💬 Личная переписка</h3>
            <span>{showPrivateChats ? '▼' : '▶'}</span>
          </div>
          
          {showPrivateChats && (
                    <div className="private-chats-list">
                    {privateChannels.map(chat => {
                    // Определяем ID собеседника
                    const otherUserId = chat.otherUserId || (() => {
                        const ids = chat.channelName?.replace('DM_', '').split('-') || [];
                        return ids.find(id => id !== user.id);
                    })();
                    
                    const unreadCount = directMessageUnread[otherUserId] || 0;

                    return (
                    <div 
                        key={chat.channelId} 
                        className="private-chat-item"
                        onClick={() => {
                        // Переключаемся на этот канал
                        if (onNavigate) {
                            onNavigate('channel', { 
                                id: chat.channelId, 
                                name: chat.otherUserName,
                                otherUserId: chat.otherUserId,
                                canWrite: chat.canWrite ?? true,   // ✅
                                canCall: chat.canCall ?? true      // ✅
                              });                        
                        }
                        }}
                    >
                        <div className="chat-avatar-wrapper">
                          <div className="chat-avatar">
                            {chat.otherUserAvatar ? (
                              <img src={chat.otherUserAvatar} alt={chat.otherUserName} className="chat-avatar-img" />
                            ) : (
                              <div className="chat-avatar-placeholder">
                                {chat.otherUserName?.[0]?.toUpperCase() || '?'}
                              </div>
                            )}
                          </div>
                          <div className={`user-status-dot ${chat.otherUserStatus === 'online' ? 'status-online' : 'status-offline'}`}></div>
                          
                        </div>
                        <div className="chat-info">
                        <div className="chat-name">{chat.otherUserName}</div>
                        <div className="chat-last-msg">{chat.lastMessage?.length > 15 ? chat.lastMessage.substring(0, 15) + '...' : chat.lastMessage}</div>
                        {/* Красный мигающий кружок с количеством */}
                        {unreadCount > 0 && (
                              <span className="unread-badge-site blink">
                                  {formatUnreadCount(unreadCount)}
                              </span>
                          )}
                        </div>
                        
                    </div>
                    )})}
              
              <button className="add-chat-btn" onClick={() => setShowUserSelect(true)}>
                + <span className="nav-label">Добавить общение</span>
              </button>
            </div>
          )}
        </div>
          <button className="logout-btn" onClick={handleLogoutClick}>
            🚪 <span className="nav-label">Выйти</span>
          
          
          </button>
          
      </div>
      
        {/* Модальное окно выбора пользователя */}
        {showUserSelect && (
        <div className="user-select-modal" onClick={() => setShowUserSelect(false)}>
          <div className="user-select-content" onClick={e => e.stopPropagation()}>
            <h3>Выберите пользователя</h3>
            <div className="users-select-list">
              {isLoading && <div className="loading-text">Загрузка пользователей...</div>}
              
              {/* РЕАЛЬНЫЕ ПОЛЬЗОВАТЕЛИ */}
              {allUsers.filter(u => !existingChatUserIds.has(u.id)).map(u => (
                <div 
                  key={u.id} 
                  className="user-select-item"
                  onClick={() => {
                    handleStartPrivateChat(u);
                  }}
                >
                  <div className="user-avatar-small">
                    {u.avatarUrl ? (
                        <img src={u.avatarUrl} alt={u.username} className="user-avatar-img" />
                    ) : (
                        <div className="user-avatar-placeholder">
                        {u.username?.[0]?.toUpperCase() || '?'}
                        </div>
                    )}
                    </div>
                    <span>{u.username || u.email || 'Пользователь'}</span>
                </div>
              ))}
              
              {!isLoading && allUsers.length === 0 && (
                <div className="no-users">Нет доступных пользователей</div>
              )}
            </div>
            <button className="cancel-btn" onClick={() => setShowUserSelect(false)}>
              Отмена
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSettings;